module.exports = __webpack_public_path__ + "static/media/myrmeleotettix_maculatus_002_APA.f13d93cf.png";